import React from "react";

const WHATSAPP_NUMBER = "33628256154";

const ProductCard = ({ product, index = 0 }) => {
  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    `Bonjour Rim' Pâtisse, je souhaite commander : ${product.name}.`
  )}`;
  return (
    <div
      className="card-hover group bg-white rounded-2xl overflow-hidden border border-[#F3D9E2] shadow-[0_8px_30px_rgba(157,24,76,0.08)] hover:shadow-[0_16px_40px_rgba(157,24,76,0.16)] transition-shadow duration-300 fade-up"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="card-img w-full h-full object-cover"
        />
        {product.price ? (
          <span className="absolute top-3 right-3 bg-white/95 text-[#9D184C] font-body text-xs font-semibold px-3 py-1.5 rounded-full shadow">
            {product.price}
          </span>
        ) : null}
      </div>
      <div className="p-5">
        <h3 className="font-title text-xl text-[#3A2A30] mb-2">{product.name}</h3>
        <p className="font-body text-sm text-[#3A2A30]/60 leading-relaxed mb-4">{product.desc}</p>
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 font-body text-xs uppercase tracking-wide text-[#9D184C] hover:text-[#7A0F39] transition-colors duration-200"
        >
          Commander →
        </a>
      </div>
    </div>
  );
};

export default ProductCard;
